import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import RequireAuth from "../auth-provider/components/required-auth/require-auth";
import Login from "../auth-provider/components/login-view/login-view";
import GuestLogin from "../auth-provider/components/guest-login/guest-login";
import CustomerRouter from "./customer-router";
import GuestRouter from "./guest-router";
import useAuth from "../auth-provider/hooks/useAuth";

const PreLoginModule = React.lazy(() => import("../modules/inds-pre-login-screen/route"));

const RootRedirect = () => {
  const location = useLocation();
  const { auth } = useAuth();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  
  if (token) {
    return <Navigate to={`/guest${location.search}`} replace />;
  }

  if (auth?.isAuthenticated) {
    return <Navigate to="/userlogin" replace />;
  }
  
  return <Navigate to="/prelogin" replace />;
};

export const AppModule = () => {
  return (
    <Routes>
      {/* Root redirect - handles token parameter */}
      <Route path="/" element={<RootRedirect />} />
      
      {/* Guest authentication and routes - GuestLogin renders GuestRouter after auth */}
      <Route path="/guest/*" element={<GuestLogin />} />
      {/* Login route */}
      <Route path="/authorize" element={<Login />} />
        {/* Prelogin and Userlogin routes */}
      <Route path="/*" element={<PreLoginModule />} />
     
      {/* Protected routes */}
      <Route element={<RequireAuth />}>
        <Route path="userlogin/*" element={<CustomerRouter />} />
      </Route> 
    </Routes>
  );
};
